<template>
    <div class="app my-app">
        <scroll class="" @refresh="refresh">
            <div class="recharge-box">
                <input class="recharge-ipt" v-model="amount" placeholder="请输入金额..." maxlength='16' ref="input1" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"/>
                <span>元</span>
            </div>
            <p class="f-strongest recharge-des">注： 金额只能输入整数，单次充值金额不超过3000元</p>
            <div class="recharge-sub" @click="rechargePay">
                <button class="btn-ok" type="submit" style="width: 90%">确认支付</button>
            </div>
            <payConfirm v-model="showPayConfirm"></payConfirm>
        </scroll>
    </div>
</template>
<script>
    import queryFun from 'queryFunList.service'
    import PayConfirm from 'PayConfirm'

    export default {
        components: {
            PayConfirm
        },
        data() {
            return {
                showPayConfirm:false,
                postParam: {},
                amount: '',
                noRecord: false,
                utils: this.$utils,
                orderId: ''
            };
        },
        mounted() {

        },
        created() {

        },
        methods: {
            refresh() {
            },
            rechargePay() {
                this.postParam = this.$store.state.paramModule.param.goRecharge.queryParam;
                this.postParam.recharge = this.$refs.input1.value * 10000
                if (parseInt(this.postParam.recharge) >= 10000 &&  parseInt(this.postParam.recharge) <= 30000000)  {
                    queryFun.submitRecharge(this.postParam).then((res) => {
                        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                            this.$utils.alert(res);
                            return;
                        }
                        this.orderId = res.data.orderId
                        this.goPay();
                    })
                } else {
                    this.$utils.alert('金额只能输入整数，单次充值金额不超过3000元')
                }
            },
            goPay() {
                //将数据存入本地
                this.$store.commit('updateParam', {
                    namespace: 'pay',
                    payInfo: {
                        cardType: this.postParam.cardType,
                        cardNo: this.postParam.cardNo,
                        orderType: 2,
                        fee: this.postParam.recharge,
                        orderId: this.orderId,
                        busiType: this.constant.BUSI_TYPE.IN_PATIENT_PAYMENT
                    },
                });
                this.showPayConfirm = true;
            },
        },
        watch: {

        }
    }
</script>
<style lang="scss">
    .my-app {
        background-color: #eff2f5;
        .recharge-box {
            background: #fff;

            .recharge-ipt {
                width: 90%;
                height: 2.25rem;
                border: none;
                font-size: .75rem;
                padding-left: 1rem;
            }
        }

        .recharge-des {
            margin-top: 1rem;
            margin-bottom: 1rem;
            font-size: .65rem;
            text-align: center;
        }

        .recharge-sub {
            text-align: center;
        }

        .recharge-inp {
            width: 80%;
            background-color: #fff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            height: 2rem;
            padding-left: 0.5rem;
            border: none;
            font-size: .7rem;
        }
    }
</style>


// WEBPACK FOOTER //
// GoRecharge.vue?1527585c